import $ from 'jquery'

const $block = $('.video-block__video-wrapper')

const el = $block.find('.youtube-video-iframe')
const overlayEl = $block.find('.img-wrapper')
const ytId = el.attr('data-id')

overlayEl.on('click', function () {
  overlayEl.remove()
  el.replaceWith(
    `<iframe src="https://www.youtube-nocookie.com/embed/${ytId}?autoplay=1" allow="autoplay">`
  )
})
